<template>
    <v-expansion-panel class="elevation-4">
        <div>
            <v-expansion-panel-header style="height: 48px" class="pr-2" hide-actions>
                <v-row
                    align="center"
                    justify="end"
                    no-gutters
                >
                    <span class="label font-weight-bold">
                        {{ title }}
                    </span>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltipOn }">
                            <v-btn v-on="tooltipOn" icon class="mr-2" :height="24" :width="24" @click="$emit('navigateToEdit')">
                                <icon :icon="'SquarePen'" medium color="primary"/>
                            </v-btn>
                        </template>
                        <span>{{ getEditTooltipText() }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltipOn }">
                            <v-btn v-on="tooltipOn" icon :height="24" :width="24" @click="$emit('closeSidebar')">
                                <icon :icon="'PanelRightClose'" medium/>
                            </v-btn>
                        </template>
                        <span>{{ $t("Collapse sidebar") }}</span>
                    </v-tooltip>
                </v-row>
            </v-expansion-panel-header>
        </div>
    </v-expansion-panel>
</template>

<script>
import {computed} from "@vue/composition-api";
import ProjectModule from "../../store/modules/project";
import {relatedTypeEnum} from "./sidebar";
import {$t} from "../../i18n";

export default {
    name: "TitlePanel",
    methods: {$t},
    props: {
        relatedType: {
            type: String,
            required: true,
        },
        relatedObject: {
            type: Object,
            default: null,
        }
    },
    setup(props) {
        const {isEventTypeCompany} = ProjectModule()

        const isEvent = () => {
            const accountId = props.relatedObject?.account_id
            return accountId && isEventTypeCompany(accountId)
        }

        const title = computed(() => {
            let result = ""
            if (props.relatedType === relatedTypeEnum.CLIENT) {
                result = $t("Client Overview")
            } else if (props.relatedType === relatedTypeEnum.PROJECT) {
                if (isEvent()) {
                    result = $t("Event Overview")
                } else {
                    result = $t("Project Overview")
                }
            }
            return result
        })

        const getEditTooltipText = () => {
            let text = ""
            if (props.relatedType === relatedTypeEnum.CLIENT) {
                text = $t("Edit client")
            } else if (props.relatedType === relatedTypeEnum.PROJECT) {
                 if (isEvent()) {
                    text = $t("Edit event")
                } else {
                    text = $t("Edit project")
                }
            }
            return text
        }

        return {
            title,
            getEditTooltipText
        }
    }

}
</script>


<style scoped lang="scss">

</style>